function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,0c-55.124,0-99.973,44.849-99.973,99.973v169.896c0,55.124,44.849,99.973,99.973,99.973 s99.973-45.109,99.973-100.551V99.973C355.973,44.849,311.13,0,256,0z M321.3,269.291c0,36.325-29.293,65.878-65.3,65.878 s-65.3-29.298-65.3-65.3V99.973c0-36.008,29.293-65.3,65.3-65.3s65.3,29.293,65.3,65.3V269.291z"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 238.664,
  y: 420.117,
  width: 34.673,
  height: 78.591
})));
var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M327.657,477.327H184.343c-9.575,0-17.336,7.761-17.336,17.336c0,9.575,7.761,17.336,17.336,17.336h143.314 c9.575,0,17.336-7.761,17.336-17.336C344.993,485.088,337.232,477.327,327.657,477.327z"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M402.203,184.343c-9.575,0-17.336,7.761-17.336,17.336v68.19c0,71.056-57.805,128.867-128.867,128.867 s-128.867-57.811-128.867-128.867v-68.19c0-9.576-7.761-17.336-17.336-17.336s-17.336,7.761-17.336,17.336v68.19 c0,90.178,73.362,163.539,163.539,163.539s163.539-73.362,163.539-163.539v-68.19 C419.539,192.104,411.779,184.343,402.203,184.343z"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M467.047,44.953c-6.773-6.773-17.741-6.773-24.514,0l-397.58,397.58c-6.773,6.767-6.773,17.747,0,24.514 c3.381,3.386,7.819,5.08,12.257,5.08c4.432,0,8.876-1.693,12.257-5.08l397.58-397.58C473.82,62.7,473.82,51.72,467.047,44.953z"
})));
var _ref7 = /*#__PURE__*/React.createElement("g", null);
var _ref8 = /*#__PURE__*/React.createElement("g", null);
var _ref9 = /*#__PURE__*/React.createElement("g", null);
var _ref0 = /*#__PURE__*/React.createElement("g", null);
var _ref1 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
var _ref16 = /*#__PURE__*/React.createElement("g", null);
var _ref17 = /*#__PURE__*/React.createElement("g", null);
var _ref18 = /*#__PURE__*/React.createElement("g", null);
var _ref19 = /*#__PURE__*/React.createElement("g", null);
const SvgMute = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMute, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mute.7f39cfe0.svg";
export { ForwardRef as ReactComponent };